/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Share2: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M16 5L14.58 6.42L12.99 4.83V16H11.01V4.83L9.42 6.42L8 5L12 1L16 5ZM20 10V21C20 22.1 19.1 23 18 23H6C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21V10C4 8.89 4.89 8 6 8H9V10H6V21H18V10H15V8H18C18.5304 8 19.0391 8.21071 19.4142 8.58579C19.7893 8.96086 20 9.46957 20 10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
